import React from 'react';
import { Field, ErrorMessage } from 'formik';
import DateInput from 'components/controls/date-input';

function ValidatedDateField(props) {
    const { name, label, placeholder, readOnly, errors, touched, setFieldValue } = props;

    let className = "form-control datepicker-input";
    let showError = errors[name] && touched[name];
    if (showError) {
        className += " is-invalid";
    }

    return (
        <div className="form-group">
        {label && <label htmlFor={name}>{label}</label>}
            <Field name={name}>
                {({ field }) => (
                    <DateInput id={name} type="text" placeholder={placeholder} readOnly={readOnly} className={className} setFieldValue={setFieldValue} autoComplete="off" {...field} />
                )}
            </Field>
            <ErrorMessage name={name} component="div" className="invalid-feedback" />
        </div >
    )
}

export default ValidatedDateField;
